import React from "react"
import TariffByKey from "./TariffByKey"
import { CaseItem, CasesList } from "./CasesList"
import overrides from "./tariffOverrides.json"
import tochka from "./logos/tochka.png"
import aviasales from "./logos/aviasales.png"
import marquiz from "./logos/marquiz.png"
import skillfactory from "./logos/skillfactory.png"
import authenticalove from "./logos/authenticalove.png"
import edpro from "./logos/edpro.png"

export function CoreCases() {
  const items: CaseItem[] = [
    {
      href: "/blog/case-tochka/",
      text: "больше не теряют обращения клиентов и увеличили конверсию из диалога в сделку до 48%",
      Logo: <img src={tochka} alt="tochka" />,
    },
  ]
  return <CasesList items={items} />
}

export function SupportCases() {
  const items: CaseItem[] = [
    {
      href: "/blog/b2b-aviasales-case/",
      text: "8 операторов обрабатывают 4000 вопросов в месяц. Максимальная скорость ответа в чате — 2 минуты",
      Logo: <img src={aviasales} alt="aviasales" />,
    },
    {
      href: "/blog/marquiz-case/",
      text: "заработали 439 183 рубля за февраль с помощью email-рассылок и разгрузили операторов чата с помощью Welcome-бота. Показатель ROMI — 1364%",
      Logo: <img src={marquiz} alt="marquiz" />,
    },
  ]
  return <CasesList items={items} />
}

export function MarketingCases() {
  const items: CaseItem[] = [
    {
      href: "/chatbot/case-skillfactory/",
      text: "на 44% увеличили конверсию из визита в покупку, получили +20% к выручке CRM-маркетинга и окупили сервис на 2500%",
      Logo: <img src={skillfactory} alt="skillfactory" />,
    },
    {
      href: "/blog/authenticalove-case/",
      text: "заработали 5,3 млн рублей за 3 месяца с помощью триггерных коммуникаций. Конверсия в заказ выросла на 48%, выручка — на 23%",
      Logo: <img src={authenticalove} alt="authenticalove" />,
    },
    {
      href: "/blog/edpro-case/",
      text: "получили 109 оплат и заработали 8,7 млн рублей за полгода. Показатель ROMI — 15 878%",
      Logo: <img src={edpro} alt="edpro" />,
    },
  ]
  return <CasesList items={items} />
}

// ====== CORE ======
export function Core({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Core" show={show} />
}

export function CoreCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Core" overrides={overrides.Core} buttons={false} show={show} />
}

// ====== SUPPORT ======
export function Support({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Support" show={show} />
}

export function SupportCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Support" overrides={overrides.Support} buttons={false} show={show} />
}

// ====== ENTERPRISE SUPPORT ======
export function SupportEnterprise({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="EnterpriseSupport" show={show} />
}

export function SupportEnterpriseCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="EnterpriseSupport" overrides={overrides.EnterpriseSupport} buttons={false} show={show} />
}

// ====== MARKETING ======
export function Marketing({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Marketing" show={show} />
}

export function MarketingCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="Marketing" overrides={overrides.Marketing} buttons={false} show={show} />
}

// ====== MARKETING EXPERT ======
export function MarketingExpertNew({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="MarketingExpert" show={show} />
}

export function MarketingExpertNewCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="MarketingExpert" overrides={overrides.MarketingExpert} buttons={false} show={show} />
}

// ====== ENTERPRISE MARKETING ======
export function MarketingEnterprise({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="EnterpriseMarketing" show={show} />
}

export function MarketingEnterpriseCustom({ show = true }: { show?: boolean }) {
  return <TariffByKey tariffKey="EnterpriseMarketing" overrides={overrides.EnterpriseMarketing} buttons={false} show={show} />
}
